import { useMemo, useState } from 'react';
import type { Workflow } from '../../../RunOrchestration/RunOrchestrationsViews/utils/workflowTypes';

export const useWorkflowSearch = (workflows: Workflow[] | undefined) => {
  const [searchTerm, setSearchTerm] = useState('');

  const activeWorkflows = useMemo(
    () =>
      workflows?.filter(
        (workflow) => !workflow.deprecated && !workflow.disabled
      ) || [],
    [workflows]
  );

  const filteredWorkflows = useMemo(() => {
    if (!searchTerm) {
      return activeWorkflows;
    }
    const lowerSearchTerm = searchTerm.toLowerCase();
    return activeWorkflows.filter((workflow) =>
      workflow.name.toLowerCase().includes(lowerSearchTerm)
    );
  }, [activeWorkflows, searchTerm]);

  return {
    filteredWorkflows,
    searchTerm,
    setSearchTerm,
  };
};
